// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page[data-v-18784f53] {\n  margin-top: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
